import { ACC_HOLDERS_TITLES, ACC_HOLDERS_TITLES_FREE, BASE_TITLES, CORPORATE_TITLES, PERSONAL_ACC_HOLDERS_TITLES } from './constants';

export const toCamelCase = (str: string) => {
  return str
    .split(' ')
    .map((word: string, index: number) => (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()))
    .join('');
};

export const slicedText = (str: string, lettersCount: number) => {
  return str.length > lettersCount ? `${str.slice(0, lettersCount)}...` : str;
};

export const selectTabs = (
  isMainSubUser: boolean,
  isSubUser: boolean,
  permanentRole: string,
  freeOfCharge: boolean,
  restrictSubUsersToCorporateOnly: boolean = false
) => {
  if (isSubUser && !isMainSubUser) return BASE_TITLES;
  if (isMainSubUser) return CORPORATE_TITLES;
  if (permanentRole === 'USER') {
    return restrictSubUsersToCorporateOnly
      ? BASE_TITLES.concat(['subscriptionManagement', 'billsManagement'])
      : PERSONAL_ACC_HOLDERS_TITLES;
  }
  if (!isMainSubUser && !isSubUser) return freeOfCharge ? ACC_HOLDERS_TITLES_FREE : ACC_HOLDERS_TITLES;

  return BASE_TITLES;
};
